import { Navigate, useLocation } from "react-router";

export default function ReportsRedirect() {
  const { pathname, search, hash } = useLocation();
  return (
    <Navigate
      to={pathname.replace(/^\/landlord(?=\/)/, "") + search + hash}
      replace
    />
  );
}
